import { createContext, useEffect, useState } from 'react';
import useCities from '../hooks/useCities';

export const FiltersContext = createContext();

function getMonthName(month) {
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return months[month - 1] || 'Todos';
}

const currentYear = new Date().getFullYear();
const currentMonth = (new Date().getMonth() + 1).toString().padStart(2, '0');

export const filtersInitialState = {
    cidade: {
        value: '',
        label: 'Todas',
    },
    ano: {
        value: currentYear.toString(),
        label: currentYear.toString()
    },
    mes: {
        value: currentMonth,
        label: getMonthName(parseInt(currentMonth))
    }
};

const FiltersProvider = ({ children, initialState }) => {
    const [filters, setFilters] = useState(() => {
        const state = initialState || filtersInitialState;

        const savedCity = localStorage.getItem('dashboard_city');

        return savedCity ? { ...state, cidade: JSON.parse(savedCity) } : state;
    });
    const { data: cities } = useCities();

    const handleChangeFilters = (values) => {
        setFilters(values);
    };

    const resetFilters = () => {
        setFilters((previous) => ({
            ...(initialState || filtersInitialState),
            cidade: previous.cidade
        }));
    };

    useEffect(() => {
        if (cities && cities.length > 0 && !filters.cidade.value) {
            onFilterChange('cidade', cities[0]);
        }
    }, [cities]);

    useEffect(() => {
        if (filters.cidade?.value) {
            localStorage.setItem(
                'dashboard_city',
                JSON.stringify(filters.cidade)
            );
        }
    }, [filters.cidade?.value]);

    const onFilterChange = (name, value) => {
        const newFilters = { ...filters, [name]: value };
        handleChangeFilters(newFilters);
    };

    return (
        <FiltersContext.Provider
            value={{
                filters,
                handleChangeFilters,
                resetFilters,
                onFilterChange,
                cities: cities || []
            }}
        >
            {children}
        </FiltersContext.Provider>
    );
};

export default FiltersProvider;
